<!-- =========================================================================================
  File Name: TabMain.vue
  Description: Device Create Main Tab content
========================================================================================== -->

<template>
  <div id="tab-main">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Серийный номер *" v-model="deviceLocal.ident" v-validate="'required|alpha_num'" name="ident" />
        <span class="text-danger text-sm"  v-show="errors.has('ident')">{{ errors.first('ident') }}</span>

        <div class="mt-4">
          <label class="vs-input--label">Тип устройства</label>
          <v-select v-model="typeLocal" :clearable="false" :options="typeOptions" v-validate="'required'" name="type" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('type')">{{ errors.first('type') }}</span>
        </div>

        <vs-input class="w-full mt-4" label="Регистр Старт-Стоп" v-model="deviceLocal.start_stop_reg" v-validate="'required'" name="start_stop_reg" />
        <!-- <vs-input class="w-full mt-4" label="Регистр Старт-Стоп" v-model="deviceLocal.start_stop_reg" v-validate="'required|alpha_spaces'" name="start_stop_reg" /> -->
        <span class="text-danger text-sm"  v-show="errors.has('start_stop_reg')">{{ errors.first('start_stop_reg') }}</span>

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" icon-pack="feather" icon="icon-chevron-left" :to="{ name: 'apps-devices-list' }">Назад</vs-button>
          <vs-button class="ml-4 mt-2" icon-pack="feather" icon="icon-rotate-cw" type="border" color="warning" @click="reset_device">Очистить</vs-button>
          <vs-button class="ml-4 mt-2" icon-pack="feather" icon="icon-plus" color="success" @click="save_changes" :disabled="!validateForm">Создать</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moduleDevice from '@/store/device/moduleDevice.js'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      deviceLocal: this.device,
      typeOptions: moduleDevice.deviceTypeList,
    }
  },
  computed: {
    typeLocal: {
      get() {
        return { label: moduleDevice.deviceTypeList[this.deviceLocal.type].label,  value: this.deviceLocal.type  }
      },
      set(obj) {
        this.deviceLocal.type = obj.value
      }
    },
    validateForm() {
      return !this.errors.any() && this.deviceLocal.ident && this.deviceLocal.start_stop_reg
    }
  },
  methods: {
    save_changes() {
      if(!this.validateForm) return

      this.$store.dispatch("device/createDevice", this.deviceLocal)
      .then(() => {
        this.$router.push({ name:'apps-devices-list' });
      })

    },
    reset_device() {
      this.deviceLocal = { type: 0, start_stop_reg: 'gspe' }
    },
  },
  created() {
    this.reset_device()
  }
}
</script>
